import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up\"><path d=\"M960 717.8c0 9.2-3.6 18.5-10.8 25.7a36.576 36.576 0 0 1-51.9 0L512 358.1 126.7 743.4c-14.4 14.4-37.5 14.4-51.9 0s-14.4-37.5 0-51.9l411-411c14.4-14.4 37.5-14.4 51.9 0l411 411c7.7 7.8 11.3 17 11.3 26.3z\" p-id=\"2232\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol